module.exports = __webpack_public_path__ + "media/fonts/Oricons-b91012b64446ea0aab69775b124bbf07.woff2";